<template>
  <div class="footer">
    <footer role="contentinfo">
      <div class="columns">
        <div class="column is-2">
          <p>
            © 2005-{{ new Date().getFullYear() }} {{ $t("message.bizpal") }}
          </p>
        </div>
        <div class="column is-8">
          <div class="home-footer">
            <div v-if="$i18n.locale == 'fr'" class="partner-logos">
              <img src="/images/PerLE_logo_fr.png" :alt="$t('logos.bizpal')" />
            </div>
            <div v-else class="partner-logos">
              <img src="/images/bizpal-logo-en.png" :alt="$t('logos.canada')" />
            </div>
            <p>
              <em>{{ $t("logos.open_service_governments") }}</em>
            </p>
          </div>
        </div>
        <div class="column is-2">
          <router-link class="is-pulled-right" to="/disclaimers">
            {{ $t("disclaimer.title") }}
          </router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "BaseFooter"
};
</script>
